export const environment = {
  production: true,
  encrypt_passcode : '1234',
  BASE_URL:'https://uat.customer.controlfms.com/'
};
